export default __webpack_public_path__ + "static/media/spinner.e5d706e2.svg";